var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _rect, _rect2, _ellipse6, _ellipse7, _path24, _path25, _path26, _path27, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarden(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "w-armor",
    cx: "40%",
    cy: "30%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2a2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#080808"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "w-armor2",
    cx: "45%",
    cy: "35%",
    r: "55%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#222020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0c0c0c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "w-ember",
    cx: "40%",
    cy: "35%",
    r: "55%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff8c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#ffaa00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "65%",
    stopColor: "#cc4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#550a00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "w-helm-dark",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#050505"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w-metal-hi",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5a5858",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#3a3838",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0a0a0a",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w-cape",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a1210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#0d0a08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#060404"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "w-glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "w-softglow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 72 95 C 55 120 35 155 28 185 C 22 205 30 222 40 225 C 48 225 52 218 55 208 C 50 195 55 175 65 155 C 72 140 80 128 88 118Z",
    fill: "url(#w-cape)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 80 98 C 62 125 42 158 35 190 C 30 210 36 228 45 228 C 38 215 42 198 50 180 C 58 162 70 145 82 128Z",
    fill: "#0e0c0a",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 28 198 C 24 210 26 222 32 228",
    fill: "none",
    stroke: "#1a1208",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 38 205 C 34 218 36 228 40 232",
    fill: "none",
    stroke: "#1a1208",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 48 210 C 44 222 46 232 50 235",
    fill: "none",
    stroke: "#12100a",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 168 95 C 185 120 205 155 212 185 C 218 205 210 222 200 225 C 192 225 188 218 185 208 C 190 195 185 175 175 155 C 168 140 160 128 152 118Z",
    fill: "url(#w-cape)",
    opacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 75 105 C 72 120 70 145 72 170 L 72 210 L 168 210 L 168 170 C 170 145 168 120 165 105 Z",
    fill: "url(#w-armor)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 75 105 C 72 120 70 145 72 170 L 72 210 L 168 210 L 168 170 C 170 145 168 120 165 105 Z",
    fill: "url(#w-metal-hi)",
    opacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 90 112 C 98 108 112 106 120 106 C 128 106 142 108 150 112 L 148 155 C 140 160 130 162 120 162 C 110 162 100 160 92 155 Z",
    fill: "#1a1a1a"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M 90 112 C 98 108 112 106 120 106 C 128 108 142 110 150 112 L 148 155 C 140 160 130 162 120 162 C 110 162 100 160 92 155 Z",
    fill: "url(#w-metal-hi)",
    opacity: 0.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M 120 108 L 120 160",
    fill: "none",
    stroke: "#3a3838",
    strokeWidth: 1.5,
    opacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 92 130 C 100 128 112 127 120 127 C 128 127 140 128 148 130",
    fill: "none",
    stroke: "#3a3838",
    strokeWidth: 1,
    opacity: 0.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 140,
    rx: 15,
    ry: 15,
    fill: "#0a0400",
    filter: "url(#w-softglow)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 140,
    rx: 15,
    ry: 15,
    fill: "url(#w-ember)",
    filter: "url(#w-glow)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 140,
    rx: 8,
    ry: 8,
    fill: "#ffcc44"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 140,
    rx: 4,
    ry: 4,
    fill: "#ff8800"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 117,
    cy: 137,
    rx: 2,
    ry: 1.5,
    fill: "#fffacc",
    opacity: 0.9
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 52 88 C 48 78 52 65 64 60 C 76 55 88 62 90 72 L 88 95 C 80 88 68 85 60 88 Z",
    fill: "url(#w-armor2)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 52 88 C 48 78 52 65 64 60 C 76 55 88 62 90 72 L 88 95 C 80 88 68 85 60 88 Z",
    fill: "url(#w-metal-hi)",
    opacity: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 188 88 C 192 78 188 65 176 60 C 164 55 152 62 150 72 L 152 95 C 160 88 172 85 180 88 Z",
    fill: "url(#w-armor2)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 188 88 C 192 78 188 65 176 60 C 164 55 152 62 150 72 L 152 95 C 160 88 172 85 180 88 Z",
    fill: "url(#w-metal-hi)",
    opacity: 0.6
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 52 92 C 42 105 36 125 38 148 C 40 162 48 172 58 178 L 65 170 C 55 162 50 148 50 132 C 50 118 55 105 62 97 Z",
    fill: "url(#w-armor)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 188 92 C 198 105 204 125 202 148 C 200 162 192 172 182 178 L 175 170 C 185 162 190 148 190 132 C 190 118 185 105 178 97 Z",
    fill: "url(#w-armor)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 48 152 C 42 158 38 168 40 178 C 42 188 52 192 62 188 C 70 184 72 175 68 165 C 62 170 55 170 52 164 Z",
    fill: "url(#w-armor2)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 192 152 C 198 158 202 168 200 178 C 198 188 188 192 178 188 C 170 184 168 175 172 165 C 178 170 185 170 188 164 Z",
    fill: "url(#w-armor2)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 98 72 C 102 65 110 62 120 62 C 130 62 138 65 142 72 L 140 88 C 132 82 125 80 120 80 C 115 80 108 82 100 88 Z",
    fill: "url(#w-armor2)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 98 72 C 102 65 110 62 120 62 C 130 65 138 68 142 72",
    fill: "none",
    stroke: "#4a4848",
    strokeWidth: 1.5,
    opacity: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 84 55 C 84 22 96 5 120 4 C 144 5 156 22 156 55 L 155 72 C 145 68 132 65 120 65 C 108 65 95 68 85 72 Z",
    fill: "url(#w-armor)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 84 55 C 84 22 96 5 120 4 C 144 5 156 22 156 55 L 155 72 C 145 68 132 65 120 65 C 108 65 95 68 85 72 Z",
    fill: "url(#w-metal-hi)",
    opacity: 0.6
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 90 58 C 90 34 100 18 120 16 C 140 18 150 34 150 58 L 149 68 C 140 64 130 62 120 62 C 110 62 100 64 91 68 Z",
    fill: "url(#w-helm-dark)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 46,
    width: 50,
    height: 12,
    rx: 2,
    fill: "#050302"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 46,
    width: 50,
    height: 12,
    rx: 2,
    fill: "#220800",
    opacity: 0.4
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 107,
    cy: 52,
    rx: 6,
    ry: 4,
    fill: "#440a00",
    opacity: 0.5
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133,
    cy: 52,
    rx: 6,
    ry: 4,
    fill: "#440a00",
    opacity: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 120 4 C 118 14 118 30 120 42",
    fill: "none",
    stroke: "#4a4848",
    strokeWidth: 2.5,
    opacity: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 86 60 C 90 52 96 46 104 42",
    fill: "none",
    stroke: "#4a4848",
    strokeWidth: 1.5,
    opacity: 0.4
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 154 60 C 150 52 144 46 136 42",
    fill: "none",
    stroke: "#4a4848",
    strokeWidth: 1.5,
    opacity: 0.4
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 94 10 Q 120 3 146 10",
    fill: "none",
    stroke: "#cc6010",
    strokeWidth: 2,
    opacity: 0.4,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 210,
    width: 22,
    height: 28,
    rx: 3,
    fill: "url(#w-armor2)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 210,
    width: 22,
    height: 28,
    rx: 3,
    fill: "url(#w-armor2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarden);
export default __webpack_public_path__ + "static/media/warden.88474b453ce82200538c88704e5e910c.svg";
export { ForwardRef as ReactComponent };